"use client";

import { usePathname } from "next/navigation";
import styles from "./LpBanner.module.scss";
import cn from "clsx";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Markdown from "@/components/atoms/Markdown";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { GAEvent, GA_EVENTS, GA_EVENTS_PAYLOAD, IGAEvent, ga_events_mapping } from "@/helpers/gaEvents";
import { useEffect, useState, useRef, useContext } from "react";
import { StorageService } from "@/helpers/storage.service";
import { ModalTypes,IModalActions } from "@/types/modal";
import {
  OTPContext,
  OTPContextProvider,
  OTPContextWrapper,
} from "@/components/sections/CommonModals/context";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import {imgPathReplace} from "@/helpers/imgPathReplace";
import shareIcon from "~/icons/share.png"
import { ModalContext } from "@/context/ModalContext";
import LandingConnectModalForm from "../LandingPageConnectModal/LandingConnectModalForm";
import useOnScreen from "@/helpers/Onscreen";

interface BannerWithImageProps {
  BannerData?: any;
  isMobile?: boolean;
  fetchPriority?: "auto" | "high";
  specializationText: string;
  Custom10PgType?: string;
  associatedPrograms?: [ProgramDetails];
  ProgramId?: string;
  NewBannerUI?: NewBannerUI;
  isSeatsFilledEnabled?: boolean;
  Numbers?: number;
  isCampusImmersionPage?: boolean;
  isLambdaApi?: boolean;
  LandingPageBrochure?: any;
  NewBannerImage?:NewBannerImage;
  Webinar?:WebinarUI
  slug?: string;
  isSpecificPage?:boolean;
}

export default function LpBanner({
  BannerData,
  isMobile,
  fetchPriority = "auto",
  specializationText,
  Custom10PgType = "",
  associatedPrograms,
  ProgramId,
  NewBannerUI,
  isSeatsFilledEnabled,
  Numbers,
  isCampusImmersionPage =false,
  isLambdaApi,
  LandingPageBrochure,
  NewBannerImage,
  Webinar,
  slug,
  isSpecificPage
}: BannerWithImageProps) {
  const [ leadFailed, setLeadFailed ] = useState(false);
  const ref = useRef(null);
  const onScreen = useOnScreen(ref);
  const { modalDispatch } = useContext(ModalContext);

  const isLeadFailed = (status:boolean)=>{
    setLeadFailed(status)
    }
  const pathName = usePathname();
  const [clickedInsideLeadForm, setClickedInsideLeadForm] = useState(false);

  const {
    PROGRAM_TAB_DOWNLOAD_BROCHURE,
    PROGRAM_CARD_DOWNLOAD_BROCHURE,
    PROGRAM_DOWNLOAD_BROCHURE,
    LEAD_INITIATE
  } = GAEvent;
  const [gaData, setGaData] = useState<IGAEvent | null>(null);
  
  function getGaSessionData(): {
    isMbaPage?: boolean;
    isNavbarClick?: boolean;
  } | null {
    return StorageService.get("programDetailsGAInfo") ?? {};
  }

  useEffect(() => {
    updateStateSession({
      formSectionName : "Download Brochure",
      leadStartingCta : BannerData?.CTA?.text || "NA"
    });
  }, []);
  useEffect(()=>{
    const stickyElement = document.getElementById('botton-nav-container');

    if(stickyElement){
      if(onScreen){
        stickyElement.style.display = 'none'
      }else{
        stickyElement.style.display = 'flex'
      }  
    }
   
  },[onScreen])


  useEffect(() => {
    try {
      const { isMbaPage = false, isNavbarClick } = getGaSessionData();
      if (ga_events_mapping?.[pathName] || isMbaPage) {
        let data: any;
        if (isNavbarClick !== undefined) {
          data = {
            ...GA_EVENTS_PAYLOAD.get(
              isNavbarClick ? PROGRAM_TAB_DOWNLOAD_BROCHURE : PROGRAM_CARD_DOWNLOAD_BROCHURE
            ),
            pageType: isNavbarClick ? "Program Nav" : "Program Card",
          };
        } else {
          data = {
            ...GA_EVENTS_PAYLOAD.get(PROGRAM_DOWNLOAD_BROCHURE),
            pageType: "Program Details",
          };
        }
        setGaData(data);
      }
    } catch (error) {
      console.error("Error parsing programDetailsGAInfo from sessionStorage", error);
    }
  }, []);


  const handleClickInsideLeadForm = (e) => {
    if (!clickedInsideLeadForm) {
      StorageService.set("timeConnectModal", true)
      
      pushToDataLayer(
        {
          event :	"lead_initiate",
          cta_text : "NA",
          section_name : "hero_banner",
          header_title :	isWebinar?webinarText:BannerData?.Heading?.text || "NA",
          page_type	: "Campaign Page",
          page_url : window.location.href || "NA"
        }
      )
      updateStateSession(
        {
          parentSection : "hero_banner"
        }
      )
      setClickedInsideLeadForm(true);
    }
  };

  const handleShare = () =>{
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        // modalType: ModalTypes.ShareIcon,
        modalData: { isMobile },
      },
    });
  }

  const handleClickOutsideLeadForm = (e) => {
    const formElement = document.getElementById("new-lead-form");
    if (formElement && !formElement.contains(e.target)) {
      setClickedInsideLeadForm(false); // Reset if clicked outside
    }
  };
  // Add event listener for clicks outside the open lead form
  useEffect(() => {
    document.addEventListener("click", handleClickOutsideLeadForm);
    return () => {
      document.removeEventListener("click", handleClickOutsideLeadForm);
    };
  }, []);
  const newurl = imgPathReplace(NewBannerUI?.bannerImage?.data.attributes.url)
  const brochure =  LandingPageBrochure?.data?.attributes?.url
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails
  const formatWebinarDate = (dateString?: string) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null; 
  
    const dayOfWeek = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const day = new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const month = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const year = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const getOrdinal = (n: number) => {
      const s = ['th', 'st', 'nd', 'rd'],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
  
    const formattedTime = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    return {
      dayOfWeek,
      day: getOrdinal(Number(day)),
      month,
      year,
      time: formattedTime,
    };
  };  
  const { dayOfWeek = "", day = "",month = "",time = "",year=""} = formatWebinarDate(Webinar?.RegistrationDate) || {};
  const isWebinar=Webinar?.isEnabled
  const webinarText= Webinar?.Description?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ').trim();
  const sponsorSubtitle =  "Post successful completion, apply for paid internship *";
  const containerClass = isSpecificPage? styles.BannerImage__containerSpecific: styles.BannerImage__container;
  return (
    <div className={`container`}>
      <div
        className={cn(containerClass, {
          [styles.WebinarImage_container]: isWebinar
        })}
        style={
          !isMobile
            ? {
                background: `url(${imgPathReplace(
                  NewBannerUI?.bannerImage?.data?.attributes.url
                )}) no-repeat`,
                backgroundPosition: "50% center",
                backgroundSize: "cover",
              }
            : {}
        }
      >
        {/* Left section with box shadow for blue */}
        <div
          className={cn(
            styles.BannerImage__leftContainer,
            "text-primary-blue",
            {'rounded-tl-[1rem] rounded-tr-[1rem]':isWebinar},
            { [styles.WebinarBanerLeft]: isWebinar,[styles.BannerImage__leftContainerSpecific]:isSpecificPage }
          )}
          style={
            isMobile
              ? {
                  background: `url(${imgPathReplace(
                    NewBannerUI?.bannerImage?.data.attributes.url
                  )}) no-repeat`,
                  backgroundPosition: "50% center",
                  backgroundSize: "cover",
                }
              : null
          }
        >
          {isWebinar ? (
            <div className={styles.WebinarBaner}>
               <div className={styles.WebinarSpeakerContainer}>
                <img
                width={500}
                height={100}
                  className={styles.WebinarImageSpeaker}
                  src={Webinar?.Speaker?.SpeakerImage?.data?.attributes?.url}
                  alt="DwebBannerGirl"
                />
              </div> 
              

              <div className={styles.WebinarSpeakerDetails}>
                <p>Speaker</p>
              </div>
              <div className={styles.WebinarSpeakerName}>
                <p className="text-yellow-500">
                  {Webinar?.Speaker?.SpeakerName}
                </p>
                <p>{Webinar?.Speaker?.Designation}</p>
              </div>
            </div>
          ) : (
            <div className={styles.leftContainer_Banner}>
              <img
                className={styles.leftContainer_image2}
                src="https://amityonline.com/_sb/Vector_95d20642dd.webp"
                alt="image"
              />
              <img
                className={styles.leftContainer_image}
                src={NewBannerImage?.data?.attributes?.url}
                alt="DwebBannerGirl"
              />
            </div>
          )}
          {/* Upper subtitle and title section */}
          {/* Subtitle */}

          {isWebinar ? (
            <>
              <div className={styles.WebinarContent}>
                <div>
                  <img
                    className={styles.amityLogo}
                    src="https://amityonline.com/_s/Frame_1000004547_1_0b21dd9e5a.webp"
                    alt="Logo"
                  />
                </div>
                <div className="flex flex-col gap-4">
                  <div
                    className={styles. webinarDescription}  
                    dangerouslySetInnerHTML={{ __html: Webinar?.Description }}
                  />
                  <div
                    className={styles.WebinarContent__title}
                    dangerouslySetInnerHTML={{ __html: Webinar?.Title }}
                  />
                  <img src="https://amityonline.com/_s/Group_13_1_4d57296490.webp" alt="SpotsImage" className={styles.hurryImage} />
                </div>
              
              </div>
            </>
          ) : (
            <>
              <div
                className={styles.mainContent}
                style={
                  !isMobile && NewBannerUI?.tagTextHTML ? { minHeight: 0 } : {}
                }
              >
                {BannerData?.ProgramType?.enabled ? (
                  <p className={cn(styles.BannerImage__subtitle, "uppercase")}>
                    {BannerData?.ProgramType?.text}
                  </p>
                ) : null}
                {/* Title */}
                {BannerData?.Heading?.enabled ? (
                  <Markdown as="h1" className={cn(styles.BannerImage__title)}>
                    {BannerData?.Heading?.text.replace(/^#\s+(.*)$/gm, "$1")}
                  </Markdown>
                ) : null}
                {BannerData?.Duration?.enabled && (
                  <div className={styles.durationWrapper}>
                    <img
                      height={35}
                      src="https://amityonline.com/_s/Vector_1_50ed5e6a3c.webp"
                      alt="calendar"
                    />
                    <p
                      className={cn(styles.BannerImage__duration, "uppercase")}
                    >
                      <span className={cn(styles.BannerImage__durationLabel)}>
                        Duration:
                      </span>{" "}
                      {BannerData?.Duration?.text}
                    </p>
                  </div>
                )}

                {/* CTA */}
                {BannerData?.CTA?.enabled && !isMobile && (
                  <>
                    <div className={cn(styles.BannerImage__cta)}>
                      <div className="flex gap-2">
                        {(!isLambdaApi || (isLambdaApi && brochure)) && (
                          <CommonButton
                            onClickStorePayload={{
                              sectionTitle: "Hero Banner",
                              parentSection: "hero_banner",
                            }}
                            GAData={gaData}
                            GADataNew={{
                              ...GA_EVENTS.get(LEAD_INITIATE),
                              cta_text: BannerData?.CTA?.text,
                              section_name: "hero_banner",
                              header_title: BannerData?.Heading?.text || "NA",
                              isPageType: true,
                              page_url: true,
                            }}
                            isEventOnly={true}
                            CTATarget="_self"
                            programTitle={BannerData?.Heading?.text}
                            type={"button"}
                            modalType={
                              isLambdaApi
                                ? ModalTypes.DownloadBrochureLP
                                : ModalTypes.DownloadBrochure
                            }
                            scroll={false}
                            webEngageEvent={{eventName: "Download Brochure Clicked" }}
                            bg="o"
                            color="#ffc907"
                            icon="/_a/icons/BlueArrowIconwithbox.svg"
                            hoverIcon="/_a/icons/BlueArrowIconwithbox.svg"
                            modalData={{
                              specializationText,
                              Custom10PgType,
                              programDetails,
                              brochure,
                            }}
                            className={styles.BannerImage__CTAStyle}
                          >
                            {BannerData?.CTA?.text}
                          </CommonButton>
                        )}

                        {!isLambdaApi && (
                          <div
                            className={styles.shareIconDiv}
                            onClick={handleShare}
                          >
                            <img
                              height={20}
                              width={20}
                              src={shareIcon.src}
                            ></img>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {BannerData?.CTA?.enabled && isMobile && (
                  <>
                    <div
                      className={cn(styles.BannerImage__cta)}
                      style={!NewBannerUI.tagTextHTML ? { top: 185 } : {}}
                    >
                      <div className="flex gap-2">
                        <CommonButton
                          GAData={gaData}
                          CTATarget="_self"
                          isEventOnly
                          GADataNew={{
                            ...GA_EVENTS.get(LEAD_INITIATE),
                            cta_text: BannerData?.CTA?.text,
                            section_name: "hero_banner",
                            header_title: BannerData?.Heading?.text || "NA",
                            isPageType: true,
                            page_url: true,
                          }}
                          onClickStorePayload={{
                            parentSection: "hero_banner",
                          }}
                          programTitle={BannerData?.Heading?.text}
                          type={"button"}
                          modalType={
                            isLambdaApi
                              ? ModalTypes.DownloadBrochureLP
                              : ModalTypes.DownloadBrochure
                          }
                          scroll={false}
                          bg="o"
                          color="#ffcc00"
                          icon="/_a/icons/BlueArrowIconwithbox.svg"
                          hoverIcon="/_a/icons/BlueArrowIconwithbox.svg"
                          modalData={{
                            specializationText,
                            Custom10PgType,
                            programDetails,
                            brochure,
                          }}
                          className={styles.BannerImage__CTAStyle}
                        >
                          {BannerData?.CTA?.text}
                        </CommonButton>
                        {!isLambdaApi && (
                          <div
                            className={styles.shareIconDiv}
                            onClick={handleShare}
                          >
                            <img
                              height={20}
                              width={20}
                              src={shareIcon.src}
                            ></img>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/* Course duration */}
              {BannerData?.Sponsor?.enabled && (
                <div className={cn(styles.sponsor)}>
                  <div>
                    <h6>{BannerData?.Sponsor?.Title}</h6>
                  </div>
                  <div>
                    <img
                      src={BannerData?.Sponsor?.Image?.data?.attributes?.url}
                      alt={
                        BannerData?.Sponsor?.Image?.data?.attributes
                          ?.alternativeText
                      }
                      loading="lazy"
                    />
                  </div>
                  
                </div>
              )}
             
            </>
          )}
           <div className={styles.sponsor_subtitle}>{isSpecificPage  && sponsorSubtitle}</div>
      
         
        </div>
        {isWebinar && (
        <div className={styles.timeDurationMweb}>
          <div className={styles.timeDurationContent}>
            <p className="text-l flex gap-2 flex-col pl-2 font-bold">100% FREE  <span className="text-l gap-2 font-bold flex">Online</span></p>
           
            {" "}
            |
            
            <div className="flex items-center ml-2 gap-2" >
              <img alt="DurationClock" height={35} width={30}  src="https://amityonline.com/_s/Frame_73cb81a84d.webp"/>
              
            <p className="flex flex-col text-sm font-bold">
               {`${day} ${month} ${year} `}
            <span>
            {`${dayOfWeek}`} {time} 
            </span>
            </p>
            </div>
          </div>
          
        </div>
      )}

        {/* Right section with image */}
        <div
          ref={ref}
          id="new-lead-form"
          className={`mb-4 ${
            isWebinar ? styles.WebinarFormWrapper : styles.leadFormWrapper
          }`}
          onClick={handleClickInsideLeadForm}
        >
          <OTPContextProvider isLambdaAPI={isLambdaApi}>
            <OTPContext.Consumer>
              {({ isHeaderHidden }) => (
                <>
                  <OTPContextWrapper isLambdaAPI={isLambdaApi}>
                    <LandingConnectModalForm
                      isWebinar={isWebinar}
                      associatedPrograms={associatedPrograms}
                      slug={slug}
                    />
                  </OTPContextWrapper>
                </>
              )}
            </OTPContext.Consumer>
          </OTPContextProvider>
        </div>
      </div>
      {isWebinar && (
        <div className={styles.timeDuration}>
          <div className={styles.timeDurationContent}>
            <p className="text-2xl font-bold">100% FREE</p>
            {" "}
            |
            <div className="flex items-center gap-2" >
              <img height={35} width={30} className={styles.DurationClock}  alt="DurationClock"  src="https://amityonline.com/_s/Frame_73cb81a84d.webp"/>
              
            <p className="flex flex-col font-bold">
               {`${day} ${month} ${year} `}
            <span>
            {`${dayOfWeek}`} {time} 
            </span>
            </p>
            </div>
            |{" "}
            <span className="text-2xl gap-2 font-bold flex items-center flex"><img className={styles.worldImage} alt="world image" height={30} width={30} src="https://amityonline.com/_s/Frame_1_ba1c5da04d.webp" />Online</span>
          </div>
        </div>
      )}
    </div>
  );
}
